import { c as _c } from "react/compiler-runtime";
import { UserPageStatsTag } from "./UserPageStatsTags";
export default function UserPageStatsTagsSet(t0) {
  const $ = _c(4);
  const {
    tags
  } = t0;
  let t1;
  if ($[0] !== tags) {
    t1 = tags.map(_temp);
    $[0] = tags;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tw-w-full tw-inline-flex tw-flex-wrap tw-gap-2 sm:tw-gap-3">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(tag) {
  return <div className={tag.classes} key={tag.id}>{tag.title}</div>;
}